export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/onboarding-close.png?fcf97be80448bcc424c8d68916260499";